// IDs espelham exatamente o FormulariosConfig.cs do backend.
// Nunca usar números diretamente no código — sempre via esta constante.
//
// Convenção:
//   1–103   : telas legadas do Horus (não alterar — IDs históricos).
//   110–249 : telas novas do Udisys Web (módulos pós-migração).

export const FORMULARIOS = {
  // ── Cadastros Gerais (Horus) ────────────────────────────────────────────
  EMPRESA_FILIAL_GRUPO:        24,
  CIDADES:                     25,
  ESTADOS:                     26,
  PAISES:                      27,
  GRUPO_PESSOAS:               29,
  PESSOAS_EMPRESAS:            30,
  USUARIOS:                    31,
  PERFIS_ACESSO:               33,
  ROTAS:                       35,
  LOCAIS_ESTOQUE:              47,
  CONTAS_CORRENTES:            54,
  CARTOES:                     55,
  CENTROS_CUSTO:               56,
  FORMAS_PAGAMENTO:            58,
  GRUPOS_DESPESA_RECEITA:      59,
  PLANO_CONTAS:                60,
  CONTAS_DESPESA_RECEITA:      61,
  CFOP:                        70,
  REGRAS_FISCAIS_NCM:          71,
  NATUREZA_OPERACAO:           73,
  TABELA_PRECOS:               86,

  // ── Configurações ──────────────────────────────────────────────────────
  GERENCIAMENTO_ACESSO:        32,
  CONFIG_GERAL:                38,

  // ── Estoque ────────────────────────────────────────────────────────────
  AJUSTE_TRANSFERENCIA:        49,
  AJUSTE_SALDO:                50,
  NF_ENTRADA:                  53,

  // ── Financeiro ─────────────────────────────────────────────────────────
  QUITACAO_LOTE:               41,
  BOLETOS:                     62,
  CAIXAS:                      64,
  CONTAS_PAGAR:                68,
  CONTAS_RECEBER:              69,

  // ── Fiscal ─────────────────────────────────────────────────────────────
  EMISSAO_NFE:                 81,
  EMISSAO_NFSE:                82,
  EMISSAO_NFCE:                92,

  // ── Contábil ───────────────────────────────────────────────────────────
  SINTEGRA:                    74,
  SPED_ICMS_IPI:               75,

  // ── Gestão ─────────────────────────────────────────────────────────────
  PAINEL_ADMINISTRATIVO:       85,
  CONTRATOS:                   89,

  // ── Operacional (Horus) ────────────────────────────────────────────────
  ATENDIMENTO_CLIENTE:         103,
  ENTREGAS:                    99,
  CARGAS:                      101,

  // ── PDV ────────────────────────────────────────────────────────────────
  CANCELAR_COMANDA:            44,
  PDV_FRENTE_CAIXA:            248,
  PDV_CONCILIACAO_CAIXA:       249,

  // ════════════════════════════════════════════════════════════════════════
  // Telas novas do Udisys Web (IDs 110+)
  // ════════════════════════════════════════════════════════════════════════

  // Cadastros Gerais novos (menu 2)
  BANCOS:                      110,
  CONDICOES_PAGAMENTO:         111,
  OPERACOES_FLUXO_CAIXA:       227,
  PLANO_CONTAS_GERENCIAL:      112,
  VEICULOS:                    113,
  PRODUTOS:                    114,
  PRODUTO_GRADE_X:             115,
  PRODUTO_GRADE_Y:             116,
  PRODUTO_OPCIONAIS:           117,
  PRODUTO_GRUPOS:              118,
  PRODUTO_SUBGRUPOS:           119,
  PRODUTO_SECOES:              120,
  PRODUTO_SUBSECOES:           121,
  PRODUTO_MARCAS:              122,
  PRODUTO_UNIDADES:            123,

  // Cadastros Fiscais novos (menu 2)
  CST_ICMS:                    130,
  CLASSIFICACAO_FISCAL:        131,
  CORRELACAO_CFOP_CST:         132,
  CCLASS_TRIB:                 133,
  BENEFICIO_FISCAL_CBENEF:     134,
  CEST:                        135,
  MONOFASICOS:                 136,
  TRIBUTOS_UF_DESTINO:         137,
  FCP_PARTILHA:                138,
  ANP_COMBUSTIVEIS:            139,
  MONOFASICO_ANP:              189,

  // Estoque (menu 3)
  ESTOQUE_POSICAO:             140,
  ESTOQUE_MOVIMENTACOES:       141,
  ESTOQUE_INVENTARIO:          142,
  ESTOQUE_REPOSICAO:           143,
  ESTOQUE_RELATORIOS:          144,
  ESTOQUE_LOTES:               145,
  ESTOQUE_HISTORICO:           146,
  ESTOQUE_ETIQUETAS:           147,
  ESTOQUE_TRANSFERENCIAS:      1481,
  ESTOQUE_REGRAS_TRANSFERENCIA: 1482,
  ESTOQUE_CICLOS_CONTAGEM:     1483,
  ESTOQUE_CONTAGEM_CICLO:      1484,
  ESTOQUE_AJUSTES:             1485,

  // Financeiro (menu 4)
  FLUXO_CAIXA:                 150,
  DASHBOARD_EXECUTIVO:         151,
  CONTROLE_CAIXAS:             152,
  RELATORIOS_FINANCEIROS:      153,
  CONCILIACAO_BANCARIA:        154,
  TRANSFERENCIAS:              155,
  CONCILIACAO_OFX:             156,
  GERENCIAMENTO_CARTAO:        157,
  PAGAMENTO_LOTE:              158,
  ATIVOS_FIXOS:                159,
  FLUXO_CAIXA_GERENCIAL:       228, // mesmo id da tela desktop (FrmFluxoCaixaSync)

  // Contábil (menu 10)
  CONTABIL_APURACOES:          160,
  CONTABIL_RAZAO:              161,
  CONTABIL_LANCAMENTO:         162,
  CONTABIL_PARAMETRIZACAO:     163,
  CONTABIL_RELATORIOS:         164,
  PLATAFORMA_CONTADOR:         165,

  // Fiscal (menu 5)
  FISCAL_IMPOSTOS:             170,

  // Operacional (menu 7)
  DAV:                         180,
  DAV_EMITIR_NFE:              1801,
  ORCAMENTOS:                  181,
  ORDEM_SERVICO:               182,
  CONDICIONAL:                 183,
  CRM:                         184,
  CRM_PIPELINE:                1841,
  CRM_DASHBOARD:               1842,
  CRM_RELATORIOS:              1843,
  PCP:                         185,
  FICHA_TECNICA:               1851,
  ETAPAS_PRODUCAO:             1852,
  PLANEJAMENTO_MRP:            1853,
  LIBERACAO_DESCONTO:          1854,
  REQUISICOES_INTERNAS:        186,
  GARANTIAS:                   187,
  PROJETOS:                    188,
  PROJETO_APONTAMENTO:         1881,
  PROJETO_APROVACAO:           1882,
  PROJETO_FATURAMENTO:         1883,

  // Compras — P2P (menu 13)
  COMPRAS_FORNECEDORES:        190,
  COMPRAS_REQUISICOES:         191,
  COMPRAS_COTACOES:            192,
  COMPRAS_ORDENS:              193,
  COMPRAS_RECEBIMENTOS:        194,
  COMPRAS_IMPORTAR_NFE:        195,
  COMPRAS_AJUSTE_PRECO:        196,
  COMPRAS_MANIFESTACAO_DFE:    197,
  COMPRAS_ALCADAS:             198,
  COMPRAS_HISTORICO_PRECOS:    199,
  COMPRAS_BUDGET:              200,
  COMPRAS_REL_FLUXO_CAIXA:     201,
  COMPRAS_REL_SPEND:           202,
  COMPRAS_REL_PERFORMANCE:     203,
  COMPRAS_REL_PEDIDOS:         204,
  COMPRAS_REL_BUDGET_VS_REAL:  205,

  // Configurações (menu 11)
  CONFIG_FISCAL:               210,
  CONFIG_WHATSAPP:             211,
  CONFIG_WHATSAPP_TEMPLATES:   212,
  CONFIG_NFSE:                 213,
  IMPORTACAO_DADOS:            214,

  // Relatórios (menu 9)
  RELATORIOS_VENDAS:           220,
  RELATORIOS_GERENCIAIS:       221,
  RELATORIOS_FISCAIS:          222,

  // Integrações (menu 14)
  INTEGRACAO_MERCADOLIVRE:     230,
  INTEGRACAO_OPEN_FINANCE:     231,
  INTEGRACAO_SMART_TEF:        232,

  // Mentor IA (menu 15)
  MENTOR_IA:                   240,

  // Transporte — CT-e / MDFe (menu Cadastros > Transporte)
  CONDUTORES:                  241,
  REBOQUES:                    242,
  VEICULOS_TRANSPORTE:         243,

  // Fiscal Transporte — emissão CT-e / MDFe / Averbação
  CTE:                         244,
  CTEOS:                       245,
  MDFE:                        246,
  AVERBACAO:                   247,

  // Dashboard configurável (250–253 reservados p/ Agentes Operacionais)
  DASHBOARD_CONFIG:            254,

  // RENAVE — estoque de veículos de revenda (260–263 reservados p/ Restaurante)
  VEICULOS_ESTOQUE:            270,
  CONFIG_RENAVE:               271,
} as const;

export type FormularioId = typeof FORMULARIOS[keyof typeof FORMULARIOS];
